import React, { useState, useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Routes } from '../../Routes/allRoutes';
import styles from './styles.module.css'
import { ReactComponent as Exclamation } from '../../Assets/Icons/exclamation-octagon.svg'
import { ReactComponent as Icon404 } from '../../Assets/Icons/404.svg'
import { useSelector } from 'react-redux';
import { IReduxState } from '../../utils/types';
import { HeaderComponent, SidePanelComponent } from '../../Components';
import GetAllowedRoutes from '../../Routes/allowedRoutes';

const NotFound = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const { pathname } = useLocation()
  const nevigate = useNavigate()
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const is_login_user = AuthState?.user && Object.keys(AuthState.user).length === 0;
  const redirect = GetAllowedRoutes(Routes)
  const AllDefindRoutes = Routes
  const findRoute = AllDefindRoutes.find((route: any) => route.path === pathname)

  useEffect(() => {
    let message = ''
    if (findRoute) {
      switch (pathname) {
        case '/jsConfig':
          message = 'ONLY DEKEL IS ALLOWED!!!'
          break;

        default:
          message = 'Access Denied!!'
          break;
      }
    } else if (!is_login_user && pathname === '/') {
      nevigate(redirect[0]?.path)
    } else {
      message = 'Page Not Found'
    }
    setErrorMessage(message)
  }, [pathname, findRoute, is_login_user, nevigate, redirect])

  return (
    <>
      {is_login_user
        ?
        <Navigate to="/login" />
        :
        <div>
          <div className={styles.content_page_header}>
            <HeaderComponent />
          </div>
          <div className="layout_wrapper">
            <div className="admin_panel_wrp">
              <div className={styles.sidebar_wrp}>
                <SidePanelComponent />
              </div>
              <div className={styles.content_page}>
                <div>
                  <div className={styles.NotFoundWrapper}>
                    <div className={styles.content}>
                      {findRoute ? <Exclamation /> : <Icon404 />}
                      <h3>{errorMessage}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>
  );
};

export default NotFound;
